module.exports = __webpack_public_path__ + "static/media/logout.1598315f.svg";